import type { TFunction } from 'i18next'
import { initialAddress } from '@dhl/input-address'
import type { ReturnRequest, ReturnPortal, CountryCode, TransportType } from '~/model'
import { getTransportTypeItems, getReturnTypeItems, getLabelTypeItems } from '~/components'
import { defaultUserCountryCode } from '~/helpers'

export const getDefaultPallets = (transportType: TransportType | undefined) => {
  switch (transportType) {
    case 'parcel':
      return 0
    case 'pallet':
      return 1
    default:
      return undefined
  }
}

export const getDefaultPackages = (transportType: TransportType | undefined) => {
  switch (transportType) {
    case 'parcel':
      return 1
    case 'pallet':
      return 0
    default:
      return undefined
  }
}

type Props = {
  returnPortal: ReturnPortal
  currentCountryCode?: CountryCode
  currentTransportType?: TransportType
  language: string
  t: TFunction
}

export const createInitialReturnRequest = ({
  returnPortal,
  currentCountryCode,
  currentTransportType,
  language,
  t,
}: Props): ReturnRequest => {
  const countryCode = currentCountryCode || (defaultUserCountryCode(returnPortal) as CountryCode)
  const [, defaultTransportType] = getTransportTypeItems(returnPortal, countryCode, t)
  const transportType = currentTransportType ?? defaultTransportType
  const [, defaultReturnType] = getReturnTypeItems(returnPortal, transportType, countryCode, t, language)
  const [, defaultLabelType] = getLabelTypeItems(returnPortal, countryCode, t)
  const defaultPallets = getDefaultPallets(transportType)
  const defaultPackages = getDefaultPackages(transportType)

  return {
    address: {
      ...initialAddress,
      postalCode: '',
      houseNumber: '',
      countryCode: {
        key: countryCode,
        label: t(`country.${countryCode}`),
      },
    },

    companyName: '',
    firstName: '',
    lastName: '',
    email: '',
    reference: '',

    transportType,
    returnType: defaultReturnType,
    returnDeclarationMechanism: defaultLabelType,

    pickupDate: undefined,
    pickupTimeWindowStart: undefined,
    pickupTimeWindowEnd: undefined,
    pallets: defaultPallets,
    packages: defaultPackages,

    packageSizeConfirmed: false,
    termsConfirmed: false,
    captcha: '',
  }
}
